module.exports = __webpack_public_path__ + "3209019c0371d8aa77de34cb6d7b532e.png";